import * as React from 'react';
import { IFilter, actions as containersActions } from 'services/containers/containers-service';
import { Filters, AutoScrollbars } from 'components';

export interface ITabLocationProps {
    filters: IFilter[];
    MUNICIPALITIES_FILTER_ID?: number;
    TOSER_FILTER_ID?: number;
}
export interface ITabLocationState {}

class TabLocationComponent extends React.Component<ITabLocationProps, ITabLocationState> {
    constructor(props: ITabLocationProps) {
        super(props);

        this.onFilterChange = this.onFilterChange.bind(this);
    }

    onFilterChange(filter_id: number, filter_value: any) {
        containersActions.setFilter({
            code: 'plots',
            id: filter_id,
            value: filter_value
        });
    }

    private renderFilterComponentById<T extends React.FC>(
        filter_id: number,
        rest_props: Partial<React.ComponentProps<T>> = {}
    ) {
        let filter = this.props.filters.find(f => f.id === filter_id);
        if (!filter) return null;
        let FilterComponent = Filters[filter.type];
        return (
            <FilterComponent
                filter={filter}
                {...rest_props}
            />
        );
    }

    render() {
        const {
            /** Площадь */
            MUNICIPALITIES_FILTER_ID = 21,
            /** ТОСЭР (льготы) */
            TOSER_FILTER_ID = 45
        } = this.props;

        return (
            <div className='location-tab-wrapper'>
                <AutoScrollbars>
                    <div className="location-filters-wrapper">
                        {this.renderFilterComponentById<typeof Filters['list_text']>(MUNICIPALITIES_FILTER_ID, {
                            className: 'municipalities-filter',
                            onFilterChange: this.onFilterChange
                        })}
                        {this.renderFilterComponentById<typeof Filters['list_text']>(TOSER_FILTER_ID, {
                            onFilterChange: this.onFilterChange
                        })}
                    </div>
                </AutoScrollbars>
            </div>
        );
    }
}

export const TabLocation = TabLocationComponent;
